import { useState, useRef } from 'react';
import { Star, Play, X, Volume2, VolumeX } from 'lucide-react';

const reviews = [
  {
    id: 1,
    name: 'MANJULA S',
    rating: 5,
    review: "Very nice service and the staff quality is top notch. I had a fantastic experience at BLR Nail Club! The team did an amazing job with my lash extensions - they truly understood my preferences and gave me a fresh, natural look.",
    location: 'Basaveshwarnagar',
    service: 'Lash Extensions',
    source: 'Google'
  },
  {
    id: 2,
    name: 'RAKSHITHA YADAV M',
    rating: 5,
    review: "He paid attention to every small detail, ensuring the finish was flawless. The nail technician took their time to understand exactly what I wanted and delivered beyond my expectations. The gel extensions have lasted so well and look absolutely beautiful.",
    location: 'Basaveshwarnagar',
    service: 'Gel Extensions',
    source: 'Google'
  },
  {
    id: 3,
    name: 'KAVI AYYAR',
    rating: 5,
    review: "Want to get luxury salon services? You must visit Nailashes! I got AVL Luxury Pedicure and Manicure along with Nail Extensions done. Their experts are so professional and give you the best service. The attention to detail is incredible!",
    location: 'Basaveshwarnagar',
    service: 'Nail Extensions & Pedicure',
    source: 'Google'
  },
  {
    id: 4,
    name: 'PRIYA SHARMA',
    rating: 5,
    review: "Best nail salon in Bangalore hands down! Got my bridal nails done here and they were absolutely stunning. The 3D nail art was so intricate and beautiful. All my guests couldn't stop complimenting my nails. Thank you BLR Nail Club!",
    location: 'CSK Mall Gunjur',
    service: 'Bridal Nail Art',
    source: 'Google'
  },
  {
    id: 5,
    name: 'SNEHA REDDY',
    rating: 5,
    review: "I've been coming here for 6 months now and the quality has been consistently excellent. The chrome nails they did last week are getting so many compliments! The staff is friendly and the hygiene standards are top-notch.",
    location: 'RR Nagar',
    service: 'Chrome Nails',
    source: 'Google'
  },
  {
    id: 6,
    name: 'ANJALI NAIR',
    rating: 5,
    review: "Finally found a salon that does perfect gel extensions! The technicians here are true artists. My nails have never looked better. The ambiance is so relaxing and premium. Worth every penny. Already booked my next appointment!",
    location: 'Basaveshwarnagar',
    service: 'Gel Extensions',
    source: 'Google'
  },
  {
    id: 7,
    name: 'DIVYA KRISHNAN',
    rating: 5,
    review: "Amazing experience at the Varthur location! Got a spa pedicure and manicure combo - it was so relaxing. The nail art design they suggested was even better than what I had in mind. Great value for money and convenient location!",
    location: 'CSK Mall Gunjur',
    service: 'Spa Mani-Pedi',
    source: 'Google'
  },
  {
    id: 8,
    name: 'MEERA IYER',
    rating: 5,
    review: "The best hair smoothening I've ever got! My frizzy hair is now so silky and manageable. The stylist was very knowledgeable and recommended the perfect treatment for my hair type. Also got my nails done - absolutely loved both services!",
    location: 'RR Nagar',
    service: 'Hair Smoothening',
    source: 'Google'
  },
  {
    id: 9,
    name: 'RASHMI GOWDA',
    rating: 5,
    review: "Visited for my engagement nails and left so happy! The French ombre design was exactly what I wanted. The staff made sure I was comfortable throughout. Clean, hygienic, and professional. This is now my go-to nail salon!",
    location: 'Sahakarnagar',
    service: 'French Ombre Nails',
    source: 'Google'
  }
];

const WallOfLove = () => {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [activeVideoSrc, setActiveVideoSrc] = useState('');
  const [isMutedLeft, setIsMutedLeft] = useState(true);
  const [isMutedRight, setIsMutedRight] = useState(true);
  const [activeReviewSet, setActiveReviewSet] = useState(0);
  const leftVideoRef = useRef(null);
  const rightVideoRef = useRef(null);

  const leftVideoSrc = "https://customer-assets.emergentagent.com/job_nail-art-lounge/artifacts/k106a8cq_Video-884.mp4";
  // Direct uploaded video file for native HTML5 video playback (autoplay, muted, loop, no controls)
  const rightVideoSrc = "https://customer-assets-jai6qajn.emergentagent.net/job_nail-art-lounge/artifacts/mljb6lgq_Seethu%20nails.mov";

  const toggleMuteLeft = (e) => {
    e.stopPropagation();
    if (leftVideoRef.current) {
      leftVideoRef.current.muted = !leftVideoRef.current.muted;
      setIsMutedLeft(!isMutedLeft);
    }
  };

  const toggleMuteRight = (e) => {
    e.stopPropagation();
    if (rightVideoRef.current) {
      rightVideoRef.current.muted = !rightVideoRef.current.muted;
      setIsMutedRight(!isMutedRight);
    }
  };

  const openVideoModal = (src) => {
    setActiveVideoSrc(src);
    setIsVideoModalOpen(true);
  };

  // Get 3 reviews at a time for display
  const displayedReviews = reviews.slice(activeReviewSet * 3, activeReviewSet * 3 + 3);
  const totalSets = Math.ceil(reviews.length / 3);

  return (
    <section className="py-16 md:py-24 bg-black" data-testid="wall-of-love">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <p className="text-[#B8860B] text-xs tracking-[0.3em] uppercase mb-3 font-light">Testimonials</p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white italic">
            The Wall of Love
          </h2>
          <p className="text-white/50 mt-3 text-sm">{reviews.length} happy customers and counting</p>
        </div>

        {/* Grid Layout with Videos on Both Sides */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 md:gap-5">
          
          {/* Column 1 - Left Video */}
          <div className="lg:col-span-1 relative order-2 lg:order-1">
            <div 
              className="relative h-[400px] lg:h-full min-h-[400px] lg:min-h-[580px] overflow-hidden cursor-pointer group"
              onClick={() => openVideoModal(leftVideoSrc)}
              data-testid="left-video-container"
            >
              {/* Autoplay Video */}
              <video
                ref={leftVideoRef}
                className="w-full h-full object-cover"
                autoPlay
                loop
                muted
                playsInline
                poster="https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&h=1200&fit=crop"
              >
                <source src={leftVideoSrc} type="video/mp4" />
              </video>
              
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20"></div>
              
              {/* Mute Toggle */}
              <button
                onClick={toggleMuteLeft}
                className="absolute top-4 right-4 w-10 h-10 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center text-white/80 hover:text-white hover:bg-black/60 transition-all z-10"
                data-testid="left-video-mute"
              >
                {isMutedLeft ? <VolumeX size={18} /> : <Volume2 size={18} />}
              </button>

              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-14 h-14 rounded-full bg-[#B8860B]/90 flex items-center justify-center shadow-2xl">
                  <Play className="text-black ml-1" size={20} fill="currentColor" />
                </div>
              </div>

              {/* Text Overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-white text-xl md:text-2xl font-light italic leading-tight">
                  After the first<br />session itself
                </p>
              </div>
            </div>
          </div>

          {/* Column 2 & 3 - Reviews (Middle Section) */}
          <div className="lg:col-span-2 flex flex-col gap-4 md:gap-5 order-1 lg:order-2">
            {/* Top Row - Review 1 & 2 */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              {/* Review 1 */}
              <div 
                className="bg-gradient-to-br from-[#8B4513] to-[#5D2E0C] p-5 md:p-6 flex flex-col justify-between min-h-[240px]"
                data-testid="review-card-1"
              >
                <div>
                  <p className="text-[#F5DEB3] text-sm leading-relaxed font-light line-clamp-5">
                    "{displayedReviews[0]?.review}"
                  </p>
                </div>
                <div className="mt-4">
                  <p className="text-white text-xs tracking-[0.15em] font-medium">{displayedReviews[0]?.name}</p>
                  <p className="text-white/50 text-[10px] mt-1">{displayedReviews[0]?.service} • {displayedReviews[0]?.location}</p>
                  <div className="flex items-center gap-1 mt-1">
                    <div className="flex">
                      {[...Array(displayedReviews[0]?.rating || 5)].map((_, i) => (
                        <Star key={i} size={11} className="text-[#FFD700]" fill="currentColor" />
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Review 2 */}
              <div 
                className="bg-gradient-to-br from-[#5D4E37] to-[#3D3225] p-5 md:p-6 flex flex-col justify-between min-h-[240px]"
                data-testid="review-card-2"
              >
                <div>
                  <p className="text-[#E8DCC8] text-sm leading-relaxed font-light line-clamp-5">
                    "{displayedReviews[1]?.review}"
                  </p>
                </div>
                <div className="mt-4">
                  <p className="text-white text-xs tracking-[0.15em] font-medium">{displayedReviews[1]?.name}</p>
                  <p className="text-white/50 text-[10px] mt-1">{displayedReviews[1]?.service} • {displayedReviews[1]?.location}</p>
                  <div className="flex items-center gap-1 mt-1">
                    <div className="flex">
                      {[...Array(displayedReviews[1]?.rating || 5)].map((_, i) => (
                        <Star key={i} size={11} className="text-[#FFD700]" fill="currentColor" />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Row - Review 3 & Image */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              {/* Review 3 */}
              <div 
                className="bg-gradient-to-br from-[#4A4A4A] to-[#2D2D2D] p-5 md:p-6 flex flex-col justify-between min-h-[240px]"
                data-testid="review-card-3"
              >
                <div>
                  <p className="text-[#D4D4D4] text-sm leading-relaxed font-light line-clamp-5">
                    "{displayedReviews[2]?.review}"
                  </p>
                </div>
                <div className="mt-4">
                  <p className="text-white text-xs tracking-[0.15em] font-medium">{displayedReviews[2]?.name}</p>
                  <p className="text-white/50 text-[10px] mt-1">{displayedReviews[2]?.service} • {displayedReviews[2]?.location}</p>
                  <div className="flex items-center gap-1 mt-1">
                    <div className="flex">
                      {[...Array(displayedReviews[2]?.rating || 5)].map((_, i) => (
                        <Star key={i} size={11} className="text-[#FFD700]" fill="currentColor" />
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Group Image */}
              <div className="relative h-[240px] overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&h=400&fit=crop"
                  alt="Happy clients at BLR Nail Club"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <p className="text-white/80 text-xs tracking-wider uppercase">Our Happy Clients</p>
                </div>
              </div>
            </div>
          </div>

          {/* Column 4 - Right Video */}
          <div className="lg:col-span-1 relative order-3">
            <div 
              className="relative h-[400px] lg:h-full min-h-[400px] lg:min-h-[580px] overflow-hidden cursor-pointer group"
              onClick={() => openVideoModal(rightVideoSrc)}
              data-testid="right-video-container"
            >
              {/* Autoplay Video - matching left video style */}
              <video
                ref={rightVideoRef}
                className="w-full h-full object-cover"
                autoPlay
                loop
                muted
                playsInline
                poster="https://images.unsplash.com/photo-1604654894610-df63bc536371?w=800&h=1200&fit=crop"
              >
                <source src={rightVideoSrc} type="video/quicktime" />
                <source src={rightVideoSrc} type="video/mp4" />
              </video>
              
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20"></div>
              
              {/* Mute Toggle */}
              <button
                onClick={toggleMuteRight}
                className="absolute top-4 right-4 w-10 h-10 rounded-full bg-black/40 backdrop-blur-sm flex items-center justify-center text-white/80 hover:text-white hover:bg-black/60 transition-all z-10"
                data-testid="right-video-mute"
              >
                {isMutedRight ? <VolumeX size={18} /> : <Volume2 size={18} />}
              </button>

              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-14 h-14 rounded-full bg-[#B8860B]/90 flex items-center justify-center shadow-2xl">
                  <Play className="text-black ml-1" size={20} fill="currentColor" />
                </div>
              </div>

              {/* Text Overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-white text-xl md:text-2xl font-light italic leading-tight">
                  Real client<br />experience
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Review Navigation Dots */}
        <div className="flex justify-center items-center gap-3 mt-8">
          {[...Array(totalSets)].map((_, i) => (
            <button
              key={i}
              onClick={() => setActiveReviewSet(i)}
              className={`w-2 h-2 rounded-full transition-all ${
                activeReviewSet === i ? 'bg-[#B8860B] w-6' : 'bg-white/30 hover:bg-white/50'
              }`}
              aria-label={`View reviews ${i * 3 + 1}-${Math.min((i + 1) * 3, reviews.length)}`}
            />
          ))}
        </div>

        {/* Google Rating Badge */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-6">
          <div className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-full px-6 py-3">
            <img 
              src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
              alt="Google" 
              className="h-4 object-contain"
            />
            <div className="h-4 w-px bg-white/20"></div>
            <div className="flex items-center gap-1.5">
              <span className="text-white font-medium text-sm">4.8</span>
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={12} className="text-[#B8860B]" fill="currentColor" />
                ))}
              </div>
            </div>
            <span className="text-white/40 text-xs">529+ reviews</span>
          </div>
          
          <a
            href="https://g.page/r/CZRSiIRDTNBFEAE/review"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#B8860B] text-sm hover:underline transition-colors"
          >
            Leave us a review →
          </a>
        </div>
      </div>

      {/* Video Modal */}
      {isVideoModalOpen && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setIsVideoModalOpen(false)}
        >
          <button
            onClick={() => setIsVideoModalOpen(false)}
            className="absolute top-4 right-4 md:top-6 md:right-6 text-white/60 hover:text-white transition-colors z-10"
          >
            <X size={28} />
          </button>
          
          <div 
            className="relative w-full max-w-lg aspect-[9/16] bg-black rounded-xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <video
              className="w-full h-full object-cover"
              autoPlay
              controls
              playsInline
            >
              <source src={activeVideoSrc} type="video/mp4" />
            </video>
          </div>
        </div>
      )}
    </section>
  );
};

export default WallOfLove;
